import { Clipboard } from '@capacitor/clipboard'

async function writeToClipboard(text) {
  try {
    await Clipboard.write({ string: text })
    console.log(await Clipboard.read())
    return true
  } catch(e) {
    console.error('Failed to write to clipboard', e)
    return false
  }
}

export { writeToClipboard }
